
import EditVendor from 'layouts/vendor/EditVendor.js';
import ProtectedRoute from "routes/protectedRoutes.js";
import Manage from 'layouts/vendor/ManageVendors';
const VendorRoutes = [

  {
    route: "vendor/edit/:id",
    key: "EditVendor-vendor",
    component: <ProtectedRoute check="logout"><EditVendor/></ProtectedRoute>
  },
  {
    route: "/vendor/list/:pageNo",
    key: "manage-vendors",
    component: <ProtectedRoute check="logout"><Manage /></ProtectedRoute>
  }

  ];

export default VendorRoutes;
 
